import { isEmpty, omitBy } from "lodash";
import { readProcessInitParams } from "screens/Public/Processes/Init/processInitParams";
import { AD_ATTRIBUTION } from "utils/constants";

const readCookie = (name) => {
  const entry = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${name}=`));
  return entry ? decodeURIComponent(entry.slice(name.length + 1)) : "";
};

const readGaClientId = () => {
  const parts = readCookie(AD_ATTRIBUTION.GA_COOKIE).split(".");
  return parts.length >= 4 ? parts.slice(-2).join(".") : "";
};

export const readAdAttribution = () => {
  const params = readProcessInitParams(window.location.href);
  const attribution = omitBy(
    {
      gclid: params.get(AD_ATTRIBUTION.GCLID_PARAM),
      gaClientId: readGaClientId(),
    },
    (value) => !value,
  );
  return isEmpty(attribution) ? null : attribution;
};
